import { imageFile } from 'common/helpers/miscHelper';

const Image = (props) => {
  const { reservationType, size = 'large', width } = props;

  if (!reservationType.image) {
    return null;
  }

  const image = imageFile(reservationType.image, size);

  return (
    <div className="c7-experience__image">
      <img src={image} alt={reservationType.title} width={width} />
    </div>
  );
};

export default Image;
